import React from 'react';
import { Link } from 'react-router-dom';

function LiveCampaignItem(props) {
  return (
    <div
      className={`shadow-1 mb-2 rounded-sm border
       px-5 py-4 ${props.type === 'Featured' ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200'}`}>
      <div className="md:flex justify-between items-center space-y-4 md:space-y-0 space-x-2">
        {/* Left side */}
        <div className="flex items-start space-x-3 md:space-x-4">
          <img className="rounded-full" width="50" height="50" src={props.image} alt={props.company} />
          <div>
            <div className="inline-flex font-semibold text-slate-800 line-clamp-3">
              {props.title}
            </div>
            <div className="text-sm">{props.text}</div>
            <div className="flex justify-between w-full">
              <div className="flex-1 text-sm text-slate-500 italic whitespace-nowrap text-left">{props.app}</div>
              <div className="flex-1 text-sm text-slate-500 italic whitespace-nowrap text-right">{props.date}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveCampaignItem;